import { config } from '@shopee-user/platform';
import { EnvConfig, LocaleConfig, Locale } from '@shopee-user/global';

const { ENV, LOCALE } = config;

export enum BusinessAppType {
  None = 0,
  ShopeePayMerchant = 1,
  FoodyDriver = 2,
}

export const SHOPEE_HOMEPAGE_LINK = `https://${EnvConfig[ENV].subDomainPrefix}${LocaleConfig[LOCALE].domain}`;

const SHOPEE_TERMS_OF_SERVICE_LINK_MAP: Record<string, string> = {
  SG: 'https://help.shopee.sg/portal/article/77148',
  MY: 'https://help.shopee.com.my/portal/article/77215',
  ID: 'https://help.shopee.co.id/portal/article/71187',
  VN: 'https://help.shopee.vn/portal/article/77243',
  PH: 'https://help.shopee.ph/portal/article/77272',
  TH: 'https://help.shopee.co.th/portal/article/77241',
  TW: 'https://help.shopee.tw/portal/article/77267',
  BR: 'https://help.shopee.com.br/portal/article/77113-Termos-de-Servi%C3%A7o ',
  MX: 'https://help.shopee.com.mx/mx/s/article/T%C3%89RMINOS-DE-SERVICIO',
  CO: 'https://help.shopee.com.co/s/article/T%C3%89RMINOS-DE-SERVICIO',
  CL: 'https://help.shopee.cl/s/article/T%C3%89RMINOS-DE-SERVICIO',
};

const SHOPEE_PRIVACY_POLICY_LINK_MAP: Record<string, string> = {
  SG: 'https://help.shopee.sg/portal/article/77149',
  MY: 'https://help.shopee.com.my/portal/article/77216',
  ID: 'https://help.shopee.co.id/portal/article/71188',
  VN: 'https://help.shopee.vn/portal/article/77244',
  PH: 'https://help.shopee.ph/portal/article/77274',
  TH: 'https://help.shopee.co.th/portal/article/77248',
  TW: 'https://help.shopee.tw/portal/article/77271',
  BR: 'https://help.shopee.com.br/portal/article/77068',
  MX:
    'https://help.shopee.com.mx/mx/s/article/Pol%C3%ADtica-de-privacidad-de-Shopee',
  CO:
    'https://help.shopee.com.co/s/article/Pol%C3%ADtica-de-privacidad-de-Shopee',
  CL: 'https://help.shopee.cl/s/article/Pol%C3%ADtica-de-privacidad-de-Shopee',
};

export const SHOPEE_TERMS_OF_SERVICE_LINK =
  SHOPEE_TERMS_OF_SERVICE_LINK_MAP[config.LOCALE] || '';

export const SHOPEE_PRIVACY_POLICY_LINK =
  SHOPEE_PRIVACY_POLICY_LINK_MAP[config.LOCALE] || '';

export const EXTERNAL_HOMEPAGE_LINK = '';

export const IVS_BASE_URL =
  LOCALE === Locale.GLOBAL
    ? `https://${EnvConfig[ENV].subDomainPrefix}${
        LocaleConfig[Locale.SG].domain
      }`
    : SHOPEE_HOMEPAGE_LINK;

export const IVS_BASE_REGEX = /^(test\.|uat\.|stable\.|staging\.|live-test\.)?shopee\.(co\.(id|th)|com\.(my|br|mx|co|ar)|sg|vn|tw|ph|cl|pl|es)$/;
